import { render, staticRenderFns } from "./FormChannelEditor.vue?vue&type=template&id=e3d9ef6a&scoped=true"
import script from "./FormChannelEditor.vue?vue&type=script&lang=js"
export * from "./FormChannelEditor.vue?vue&type=script&lang=js"
import style0 from "./FormChannelEditor.vue?vue&type=style&index=0&id=e3d9ef6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d9ef6a",
  null
  
)

export default component.exports